import store from '../configureStore';
import { apiGet, apiPost } from './apiUtil';

export const getAllUsers = (fromGroup?: { id: { S: string }; parent: { S: string } }) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  let groupId: string;
  let parentId: string;
  if (fromGroup) {
    groupId = fromGroup.id.S;
    parentId = fromGroup.parent.S;
  } else {
    groupId = currentUserGroup;
    parentId = 'root';
  }
  const getAllUsersInit = {
    headers: header,
  };

  return apiGet(
    `/user/all?gid=${groupId}&parent=${parentId}`,
    getAllUsersInit,
  );
};

export const getWorkspaceUsers = (gid?: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();

  const getAllUsersInit = {
    headers: header,
  };

  return apiGet(
    `/user/all?gid=${gid || currentUserGroup}`,
    getAllUsersInit,
  );
};

export const addUser = (uid: string, userRole: string, addToworkspaceId?: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const workspaceId = addToworkspaceId || currentUserGroup;
  const addUserInit = {
    headers: header,
    body: `useruid=${uid}&userrole=${userRole}`,
  };
  return apiPost(`/user/add?gid=${workspaceId}`, addUserInit);
};

export const addInvitedUser = (invitationId: string, firstName: string, lastName: string, header: Record<string, string>) => {
  const addInvitedUserInit = {
    headers: header,
    body: `invid=${invitationId}&firstname=${firstName}&lastname=${lastName}`,
  };
  return apiPost('/user/add', addInvitedUserInit);
};

export const removeInvitedUser = (id: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const init = {
    headers: header,
  };
  return apiGet(`/link/delete/${id}?gid=${currentUserGroup}`, init);
};

export const addNewUser = (email: string, userRole: string, addToworkspaceId?: string, projectId?: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const workspace = addToworkspaceId || currentUserGroup;
  let body = `userrole=${userRole}&email=${email}`;
  // if projectId is present, we will add user to project as well
  if (projectId) {
    body += `&project=${projectId}`;
  }

  const addUserInit = {
    headers: header,
    body,
  };

  return apiPost(`/user/add?gid=${workspace}`, addUserInit);
};

export const addGuestUser = (email: string, projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();

  const body = `email=${email}&project=${projectId}`;

  const addUserInit = {
    headers: header,
    body,
  };

  return apiPost(`/user/add-guest?gid=${currentUserGroup}`, addUserInit);
};

export const getUsersGroups = () => {
  const {
    project: { header },
  } = store.getState();
  const getUsersGroupsInit = {
    headers: header,
  };
  return apiGet('/user/groups', getUsersGroupsInit);
};

export const usersByProject = (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const usersByProjectInit = {
    headers: header,
  };
  return apiGet(
    `/user/by-project?gid=${currentUserGroup}&project=${projectId}`,
    usersByProjectInit,
  );
};

export const updateUserAccess = (uid: string, projectId: string, access: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const updateUserAccessInit = {
    headers: header,
    body: `useruid=${uid}&project=${projectId}&access=${access}`,
  };
  return apiPost(
    `/user/update-access?gid=${currentUserGroup}`,
    updateUserAccessInit,
  );
};

export const updateUserRole = (uid: string, role: string, groupId: string) => {
  const {
    project: { header },
  } = store.getState();
  const updateUserAccessInit = {
    headers: header,
    body: `useruid=${uid}&userrole=${role}`,
  };
  return apiPost(`/user/update?gid=${groupId}`, updateUserAccessInit);
};

export const updateUserImage = (userUid: string, storageResponseKey: string, name: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const resourceS3Path = `private/${identityId}/${storageResponseKey}`;
  const updateUserImageInit = {
    headers: header,
    body: `useruid=${userUid}&image=${resourceS3Path}&name=${name}`,
  };
  return apiPost(
    `/user/update-image?gid=${currentUserGroup}`,
    updateUserImageInit,
  );
};

export const removeUserImage = (userUid: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const updateUserImageInit = {
    headers: header,
    body: `useruid=${userUid}&image=no-image`,
  };
  return apiPost(
    `/user/update-image?gid=${currentUserGroup}`,
    updateUserImageInit,
  );
};

export const getCurrentUserInfo = (gid?: string) => {
  const {
    project: { header },
  } = store.getState();
  const getCurrentUserInfoInit = {
    headers: header,
  };
  const endpoint = gid ? `/user/myself?gid=${gid}` : '/user/myself';
  return apiGet(endpoint, getCurrentUserInfoInit);
};

export const getCurrentUserInfoInWorkspace = (workspaceId: string) => {
  const {
    project: { header },
  } = store.getState();
  const getCurrentUserInfoInit = {
    headers: header,
  };
  return apiGet(`/user/myself?gid=${workspaceId}`, getCurrentUserInfoInit);
};

export const removeUserFromWorkspace = (uid: string, workspaceId: string) => {
  const {
    project: { header },
  } = store.getState();
  const removeUserInit = {
    headers: header,
    body: `useruid=${uid}`,
  };
  return apiPost(
    `/user/remove-from-group?gid=${workspaceId}`,
    removeUserInit,
  );
};

export const getInvitedUserEmail = (invitationId: string) =>
  apiGet(`/user/invitation/${invitationId}`);

export const updateUserName = (firstName: string, lastname: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const updateUserFirstNameInit = {
    headers: header,
    body: `firstname=${firstName}&lastname=${lastname}`,
  };
  return apiPost(
    `/user/update-details?gid=${currentUserGroup}`,
    updateUserFirstNameInit,
  );
};

export const updateUserEmail = (email: string, workspaceId: string) => {
  const {
    project: { header },
  } = store.getState();
  const updateUserEmailInit = {
    headers: header,
    body: `email=${email}`,
  };
  return apiPost(
    `/user/update-details?gid=${workspaceId}`,
    updateUserEmailInit,
  );
};
